<!-- [ vi-tab ]    ||        [ vi-mainbet |  vi-sidebet ] | vi-confirm ] -->
<app-loader></app-loader>
<div class="bodyWrapper" [ngClass]="{'vi-tab' : isTab}">
    <router-outlet></router-outlet>
</div>
<!-- ## Note:- Add "modal-open" class on "body" tag to open this backdrop -->
<div class="overlay-backdrop" (click)="closeModals()"></div>
<div class="overlay-fix" (click)="closeModals()"></div>